import(/* webpackMode: "eager", webpackExports: ["I","r","O","g","U","k","z","q","o","y","h","n","w","x","B","j","A","p","t","v","l","u","i","a","m","d","S","s","b","get","c","e","f"] */ "/app/node_modules/swr/dist/_internal/config-context-client-v7VOFo66.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["S"] */ "/app/node_modules/swr/dist/index/config-client-Bi4rgVRk.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/dialogs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalMainScripts"] */ "/app/src/modules/client/wrappers/ExternalMainScripts/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/CasinoClockUTC/CasinoClockUTC.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/FAQ/FAQContainer.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/FAQ/FAQSection.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/FlipWrapper/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/FooterWrapper/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/LazyLoad/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/ReceiveBonusesNotice/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/skeletons/FooterSkeleton/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/skeletons/HeaderSkeleton/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/skeletons/LobbySliderSkeleton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useAuthCookies.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useInfoProject.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useLicenseScript.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useLoyaltySSESubscription.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useNDBConfirmEmailModals.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useOrganicStag.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/usePrefilledNdbCouponSync.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/deposit/hooks/useABIncreasePrevDep.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/deposit/hooks/useDepositBonus.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/deposit/hooks/useErrorsNotifications.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/deposit/hooks/useToggleBonusCode.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/googleAnalytics/hooks/useConfigGAHook.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/BonanzaPromoDashboardContent/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/BonanzaPromoSnackbar/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/ClockUTC/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useBonanzaPromo"] */ "/app/src/modules/promotions/hooks/useBonanzaPromo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/hooks/useDiceRoll.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/hooks/usePromocodeActivation.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/hooks/usePromotionsMenuData.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/hooks/useQuestPromo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/hooks/useScratchGameLootbox.ts");
;
import(/* webpackMode: "eager", webpackExports: ["CommonStoreContext"] */ "/app/src/store/commonStore/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["usePersistentFormsSlice","getState","PersistentFormName","PaymentMethodPersonalInfo","WithdrawPersonalInfo"] */ "/app/src/store/commonStore/slices/persistant/usePersistentFormsSlice.ts");
;
import(/* webpackMode: "eager" */ "/app/src/store/modalsStore/index.ts");
;
import(/* webpackMode: "eager" */ "/app/src/store/StoreClient.ts");
